<template>
    <BreadCrumb PageTitle="Etats des casiers" />
    <EtatColisParCasier />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EtatColisParCasier from "../../components/Etats/EtatColisParCasier.vue";

  
    export default defineComponent({
      name: "EtatColisParCasierPage",
      components: {
        BreadCrumb,
        EtatColisParCasier,
      },
    });
  </script>